import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { Link } from "react-router-dom";
import "./Header.css";
import logo from '../../assets/logo.svg'

const LINKS = [
  { label: "COMO PARTICIPAR", href: "#como-participar" },
  { label: "CRONOGRAMA", href: "#cronograma" },
  { label: "FAQ", href: "#duvidas" },
  { label: "REGULAMENTO COMPLETO", href: "#regulamento" },
  { label: "CONSULTAR NÚMEROS", href: "/login" },
];

export function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen((prev) => !prev);
  const closeMenu = () => setMenuOpen(false);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [menuOpen]);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 920) setMenuOpen(false);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <header className="header">
      <img src={logo} alt="Rafael Toro Academia de Finanças" className="image-logo" />
      <nav className="header__nav" aria-label="Navegação principal">
        {LINKS.map((link) =>
          link.href.startsWith("#") ? (
            <a key={link.href} className="header__link" href={link.href}>
              {link.label}
            </a>
          ) : (
            <Link key={link.href} className="header__link" to={link.href}>
              {link.label}
            </Link>
          )
        )}
      </nav>

      <button
        className={`header__hamburger${menuOpen ? " header__hamburger--open" : ""}`}
        onClick={toggleMenu}
        aria-label={menuOpen ? "Fechar menu" : "Abrir menu"}
        aria-expanded={menuOpen}
      >
        <span className="header__hamburger-bar" />
        <span className="header__hamburger-bar" />
        <span className="header__hamburger-bar" />
      </button>

      {ReactDOM.createPortal(
        <>
          <div
            className={`header__overlay${menuOpen ? " header__overlay--visible" : ""}`}
            onClick={closeMenu}
            aria-hidden="true"
          />
          <nav
            className={`header__mobile-nav${menuOpen ? " header__mobile-nav--open" : ""}`}
            aria-label="Menu móvel"
            aria-hidden={!menuOpen}
          >
            {LINKS.map((link) =>
              link.href.startsWith("#") ? (
                <a
                  key={link.href}
                  className="header__mobile-link"
                  href={link.href}
                  onClick={closeMenu}
                >
                  {link.label}
                </a>
              ) : (
                <Link
                  key={link.href}
                  className="header__mobile-link"
                  to={link.href}
                  onClick={closeMenu}
                >
                  {link.label}
                </Link>
              )
            )}
          </nav>
        </>,
        document.body
      )}
    </header>
  );
}
